import {
	CustomizedCadenceBulkAccountLoader,
	PollingVelocityClientAccountSubscriber,
} from '@velocity-exchange/sdk';
import { PublicKey } from '@solana/web3.js';
import { useCallback } from 'react';
import invariant from 'tiny-invariant';
import useVelocityClient from 'src/hooks/useVelocityClient';

export const useUpdateAccountLoaderCadence = () => {
	const velocityClient = useVelocityClient();

	const updateAccountLoaderCadence = useCallback(
		(publicKey: PublicKey, ms: number) => {
			if (!velocityClient) return;

			const accountSubscriber = velocityClient.accountSubscriber;

			if (!accountSubscriber) return;

			if (accountSubscriber instanceof PollingVelocityClientAccountSubscriber) {
				if (
					accountSubscriber.accountLoader instanceof
					CustomizedCadenceBulkAccountLoader
				) {
					accountSubscriber.accountLoader.setCustomPollingFrequency(
						publicKey,
						ms
					);
				} else {
					invariant(
						false,
						"can't call updateAccountLoaderCadence if Account subscriber is not a CustomizedCadenceBulkAccountLoader"
					);
				}
			}
		},
		[velocityClient]
	);

	return { updateAccountLoaderCadence };
};
